export const APPLE_DEVICES: string[] = [
    "iPhone",
    "iPod",
    "iPad",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad Simulator",
    "iOS",
    "MacIntel"
]